import React, { forwardRef } from 'react';
import { Box, Text } from '@chakra-ui/react';

const FileContextMenu = forwardRef(({ file, onMarkAsIndex, onMarkAsSource, onRename, onDelete }, ref) => {

    const ContextMenuItem = ({ onClick, children }) => {
        return (
            <Box
                as="button"
                w="94%"
                textAlign="left"
                ml="3%"
                px="3"
                py="1.5"
                borderRadius="4px"
                cursor="pointer"
                bg="transparent"
                color="#cccccc"
                fontSize="13px"
                fontFamily="'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
                display="flex"
                alignItems="center"
                _hover={{
                    bg: "#094771",
                    color: "white"
                }}
                onClick={onClick}
                transition="none"
            >
                <Text isTruncated>
                    {children}
                </Text>
            </Box>
        );
    };

    return (
        <Box
            ref={ref}
            className='more_option'
            position="absolute"
            top="25px"
            right="10px"
            minW="180px"
            bg="#252526"
            border="1px solid #454545"
            boxShadow="0px 4px 6px rgba(0, 0, 0, 0.3)"
            borderRadius="4px"
            py="4px"
            zIndex={10000}
            display="flex"
            flexDirection="column"
        >
            {(!file.is_index) && (
                <ContextMenuItem onClick={onMarkAsIndex}>
                    Mark as Index
                </ContextMenuItem>
            )}

            <ContextMenuItem onClick={onMarkAsSource}>
                Make as source
            </ContextMenuItem>

            <ContextMenuItem onClick={onRename}>
                Rename
            </ContextMenuItem>

            <Box w="90%" h="1px" bg="#454545" mx="auto" my="4px" />

            <ContextMenuItem onClick={onDelete}>
                Delete
            </ContextMenuItem>
        </Box>
    );
});

export default FileContextMenu;
